import { addMaterial } from "~/store/ducks/user/dlsUserMaterials";
import { selectCurrentDlsCategory } from "~/store/selectors/dls";
import { selectDisplayedPages } from "~/store/selectors/page";

export const addDlsUserMaterial = material => (dispatch, getState) => {
  const state = getState();
  const activeCategory = selectCurrentDlsCategory(state);
  const activePages = selectDisplayedPages(state);
  const pages = activeCategory.type === "page" ? activePages : [];

  const materialWithCategory = {
    ...material,
    pages
  };

  dispatch(addMaterial(materialWithCategory));
};
